import Cookies from "universal-cookie";
//TODO why are some cookies session and why are some timestamped?
// What is the difference?

// Taken from Quirks mode

export function createCookie(name, value, days) {
  let expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // ) removed
    expires = "; expires=" + date.toGMTString(); // + added
  }
  document.cookie = name + "=" + value + expires + ";path=/"; // + and " added
}

export function createCookieInMinutes(name, value, minutes) {
  let expires = "";
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + minutes * 60 * 1000); // ) removed
    expires = "; expires=" + date.toGMTString(); // + added
  }
  document.cookie = name + "=" + value + expires + ";path=/"; // + and " added
}

export function getCookie(cookieName) {
  let match = document.cookie.match(new RegExp(cookieName + `=([^;]+)`));
  if (match) return match[1];
}
export function getCookiesServerSide(request, key = " ") {
  // console.warn('| Deprecation Warning: app/util/utils/getCookies is deprecated in favour of /app/util/cookies/getCookie.  Please update your reference by April 2020');
  let cookies = null;
  if (request) {
    // if request is server side get cookie
    cookies = new Cookies((request.headers && request.headers.cookie) || null);
  } else {
    // if request is client side get cookie
    cookies = new Cookies();
  }
  return key === "*" ? cookies.getAll() : { [key]: cookies.get(key) };
}

export function deleteCookie(cookieName) {
  document.cookie = cookieName + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
export function getCookieValue(name) {
  var b = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");

  return b ? b.pop() : "";
}
